import React from "react";
import meetingPic from '../../../assets/images/reunion.jpg'
import classes from './meeting.module.css';

const MeetingPic = (props) => {
    return(
        <div className={classes.Pic}>
            <img src={meetingPic} alt="pic"/>
        </div>
    )
}
export default MeetingPic;